"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMyPageDomain = void 0;
var types_1 = require("./types");
var getMyPageDomain = function (client, stack, isProduction) {
    var _a, _b;
    var _c;
    var customDomains = (_a = {},
        _a[types_1.ClientShortHandName.SA] = function (s, p) { return (s == "abo" || p) ? null : "sa.mypage.pre.schibsted.digital"; },
        _a);
    var customDomain = (customDomains[client] || (function () { return null; }))(stack, isProduction);
    var prefixAbo = isProduction ? 'kundeportal' : 'test-kundeportal';
    var prefixUrs = isProduction ? 'www' : 'stage';
    var prefix = stack === "abo" ? prefixAbo : prefixUrs;
    var domains = (_b = {},
        _b[types_1.ClientShortHandName.BAREASANE] = null,
        _b[types_1.ClientShortHandName.BEDRIFT] = null,
        _b[types_1.ClientShortHandName.DNB] = null,
        _b[types_1.ClientShortHandName.MPL] = null,
        _b[types_1.ClientShortHandName.OMNI] = null,
        _b[types_1.ClientShortHandName.OP] = null,
        _b[types_1.ClientShortHandName.SCH] = null,
        _b[types_1.ClientShortHandName.WELLOBE] = null,
        _b[types_1.ClientShortHandName.VEKTKLUBB] = null,
        _b[types_1.ClientShortHandName.AP] = 'aftenposten.no',
        _b[types_1.ClientShortHandName.ASK] = 'av-avis.no',
        _b[types_1.ClientShortHandName.BTI] = 'bt.no',
        _b[types_1.ClientShortHandName.BYN] = 'bygdanytt.no',
        _b[types_1.ClientShortHandName.DP] = 'e24dinepenger.no',
        _b[types_1.ClientShortHandName.E24] = stack === "abo" ? 'e24dinepenger.no' : 'e24.no',
        _b[types_1.ClientShortHandName.RB24] = 'randaberg24.no',
        _b[types_1.ClientShortHandName.SA] = 'aftenbladet.no',
        _b[types_1.ClientShortHandName.STR] = 'strilen.no',
        _b[types_1.ClientShortHandName.SVD] = 'svd.se',
        _b[types_1.ClientShortHandName.VG] = 'vg.no',
        _b[types_1.ClientShortHandName.VNY] = 'vestnytt.no',
        _b[types_1.ClientShortHandName.AB] = isProduction ? 'aftonbladet.se' : 'aftonbladet.dev',
        _b);
    var domain = customDomain || ((_c = domains[client]) === null || _c === void 0 ? void 0 : _c.replace(/^/, "".concat(prefix, ".")));
    return domain ? "https://".concat(domain) : null;
};
exports.getMyPageDomain = getMyPageDomain;
var getMyPageUrl = function (client, stack, isProduction, subscriptionNumber) {
    var basePath = (client === types_1.ClientShortHandName.SVD || client === types_1.ClientShortHandName.AB)
        ? '/minsida' : '/minside' + (stack === "abo" ? '' : '/abonnement');
    var path = basePath + (subscriptionNumber && stack === "abo" ? "/".concat(subscriptionNumber) : '');
    var domain = (0, exports.getMyPageDomain)(client, stack, isProduction);
    return domain ? "".concat(domain).concat(path) : null;
};
exports.default = getMyPageUrl;
//# sourceMappingURL=getMyPageUrl.js.map